<template>
	<div class="filter form">
		<div class="item" data-size="big">
			<input class="textbox" type="text" :placeholder="localizer.get('PrivateArea.Common.ProjectDetail_FilterBox_SearchText_Placeholder')" @keyup.enter="setSearch()" v-model="searchText" />
		</div>
		<div class="item">
			<div class="checkbox" :data-accentcolor="accentColor ? true : false">
				<div class="label">
					<input type="checkbox" data-val="true" id="IsApproved" name="IsApproved" value="true" v-model="isApproved">
					<label for="IsApproved">{{ localizer.get("PrivateArea.Common.ProjectDetail_FilterBox_AssetApproved") }}</label>
				</div>
			</div>
		</div>
		<div class="item" data-cta="multi">
			<div class="cta">
				<button class="button" @click="setSearch()" data-size="small" :style="[{'background-color': accentColor}]">{{ localizer.get("PrivateArea.Common.ProjectDetail_FilterBox_SearchButton") }}</button>
			</div>
			<div class="cta" v-if="searchTextFilter !== '' || isApprovedFilter">
				<button class="button" data-type="link" @click="resetSearch()">
					{{ localizer.get("PrivateArea.Common.ProjectDetail_FilterBox_ResetFilters") }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import Localizer from "@Scripts/Common/Localizer";

const props = defineProps<{
	accentColor: string;
}>();

const route = useRoute();
const localizer = Localizer;

const searchTextFilter = computed(() => (<any>window).App.bag.SearchText);
const isApprovedFilter = computed(() => (<any>window).App.bag.IsApproved === "True" ? true : false);
const projectDetailUrl = computed(() => (<any>window).App.bag.ProjectDetailUrl);

const searchText = ref(searchTextFilter.value);
const isApproved = ref(isApprovedFilter.value);

onMounted(() => {
	let searchObj = JSON.parse(window.sessionStorage.getItem("AssetSearch"));

	if (route.query.searchText) {
		searchText.value = <string>route.query.searchText;
	} else if (searchObj?.searchText) {
		searchText.value = searchObj.searchText;
	}

	if (route.query.isApproved) {
		isApproved.value = route.query.isApproved === "true";
	} else if (searchObj?.isApproved) {
		isApproved.value = searchObj.isApproved;
	}
});

function resetSearch() {
	searchText.value = null;
	isApproved.value = false;

	setSearch();
}

function setSearch() {
	let filters = [],
		filterCount = 0,
		queryString = "";

	if (searchText.value) {
		filters.push("searchText=" + searchText.value);
		filterCount++;
	}

	if (isApproved.value) {
		filters.push("isApproved=" + isApproved.value);
		filterCount++;
	}

	if (filterCount !== 0) {
		queryString = filters.join("&");

		window.sessionStorage.setItem("AssetSearch", JSON.stringify({ searchText: searchText.value, isApproved: isApproved.value }));

		window.location.href = projectDetailUrl.value + "?" + queryString;
	} else {
		window.sessionStorage.removeItem("AssetSearch");
		window.location.href = projectDetailUrl.value;
	}
}
</script>
